import DocumentI from '@interfaces/patient/patient-documents';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export const DocumentsSlice = createSlice({
    name: 'patient',
    initialState: {
        docs: []
    } as {docs: DocumentI[]},
    reducers: {
        setDocs: (state, action: PayloadAction<DocumentI[]>) => {
            state.docs = action.payload;
        },
    },
});

export const { setDocs } = DocumentsSlice.actions;
export default DocumentsSlice.reducer;
